/** FunctionFormSchema entity */
export interface FunctionFormSchema {
  /**
   * FunctionFormSchema ID. Matches ID of the function for which it was created.
   * @format GUID
   * @readonly
   */
  id?: string | null;
  /**
   * The JSONSchema for FormTemplate, specifying input title, description, type, constraints.
   * @readonly
   */
  jsonSchema?: Record<string, any> | null;
  /**
   * The UI Schema for FormTemplate, containing the input display specification, currently only the placeholders.
   * @readonly
   */
  uiSchema?: Record<string, any> | null;
  /**
   * Field keys by input source.
   * @readonly
   * @maxSize 100
   */
  formFieldSources?: FormFieldSource[];
}

export enum FormFieldSourceType {
  SPI_CONFIG = 'SPI_CONFIG',
  ACTION_SET_VARIABLES = 'ACTION_SET_VARIABLES',
  ACTION_OUTPUT = 'ACTION_OUTPUT',
  ACTION_OUTPUT_1 = 'ACTION_OUTPUT_1',
  ACTION_OUTPUT_2 = 'ACTION_OUTPUT_2',
  ACTION_OUTPUT_3 = 'ACTION_OUTPUT_3',
  ACTION_OUTPUT_4 = 'ACTION_OUTPUT_4',
  ACTION_OUTPUT_5 = 'ACTION_OUTPUT_5',
  ACTION_OUTPUT_6 = 'ACTION_OUTPUT_6',
  ACTION_OUTPUT_7 = 'ACTION_OUTPUT_7',
  ACTION_OUTPUT_8 = 'ACTION_OUTPUT_8',
  ACTION_OUTPUT_9 = 'ACTION_OUTPUT_9',
  ACTION_CONDITION = 'ACTION_CONDITION',
  ACTION_APP_DEFINED_SET_VARIABLES = 'ACTION_APP_DEFINED_SET_VARIABLES',
}

/** @enumType */
export type FormFieldSourceTypeWithLiterals =
  | FormFieldSourceType
  | 'SPI_CONFIG'
  | 'ACTION_SET_VARIABLES'
  | 'ACTION_OUTPUT'
  | 'ACTION_OUTPUT_1'
  | 'ACTION_OUTPUT_2'
  | 'ACTION_OUTPUT_3'
  | 'ACTION_OUTPUT_4'
  | 'ACTION_OUTPUT_5'
  | 'ACTION_OUTPUT_6'
  | 'ACTION_OUTPUT_7'
  | 'ACTION_OUTPUT_8'
  | 'ACTION_OUTPUT_9'
  | 'ACTION_CONDITION'
  | 'ACTION_APP_DEFINED_SET_VARIABLES';

export interface FormFieldSource {
  /** The source for the input field. */
  formFieldSourceType?: FormFieldSourceTypeWithLiterals;
  /**
   * The field keys of the source. Limited by the target field constraints of the FormTemplate
   * @readonly
   * @maxSize 1000
   * @maxLength 200
   */
  formFieldKeys?: string[];
}

export interface GetFunctionFormSchemaRequest {
  /**
   * ID of the function of the returned FunctionFormSchema.
   * @format GUID
   */
  functionId: string;
}

export interface GetFunctionFormSchemaResponse {
  /** The requested FunctionFormSchema. */
  functionFormSchema?: FunctionFormSchema;
}
